import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMagiskComponent } from './simple-icons-magisk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMagiskComponent ],
    exports:      [ SimpleIconsMagiskComponent ],
    bootstrap:    []
})
export class SimpleIconsMagiskModule {}
